import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getptProgramHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "ptprogram", ...action.payload }),
		);
		yield put({
			type: types.GET_PT_PROGRAM_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_PT_PROGRAM_ERROR,
			payload,
		});
	}
}

export function* getptProgramWatcherSaga() {
	yield takeLatest(types.GET_PT_PROGRAM_START, getptProgramHandlerSaga);
}

//create

//delete

function* deleteptProgramHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("ptprogram", action.payload),
		);
		yield put({
			type: types.DELETE_PT_PROGRAM_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_PT_PROGRAM_ERROR,
			payload,
		});
	}
}

export function* deleteptProgramWatcherSaga() {
	yield takeLatest(types.DELETE_PT_PROGRAM_START, deleteptProgramHandlerSaga);
}

//update
